<template>
    <div class="pt-3">
        <meus-lotes-itens-vencedores v-model="fornecedor.meusLotesEItensVencedores"
                                     :casasDecimais="quantidadeCasasDecimais"
                                     :validarLancesPor="validarLancesPor"
                                     :prefixSuffixValor="prefixSuffixValor"
                                     :criterioJulgamento="criterioJulgamento"
                                     :simboloCriterioJulgamento="simboloCriterioJulgamento"
                                     v-if="fornecedor.meusLotesEItensVencedores.length > 0"/>

        <todos-lotes-itens v-model="fornecedor.resultadoTodosLotesEItens"
                           :casasDecimais="quantidadeCasasDecimais"
                           :validarLancesPor="validarLancesPor"
                           :prefixSuffixValor="prefixSuffixValor"
                           :placeHolderValorOuDesconto="placeHolderValorOuDesconto"
                           :criterioJulgamento="criterioJulgamento"
                           :simboloCriterioJulgamento="simboloCriterioJulgamento"/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import MeusLotesItensVencedores from '@/views/pages/fornecedor/resultado/resultado-final/meus-lotes-itens-vencedores/MeusLotesItensVencedores'
import TodosLotesItens from '@/views/pages/fornecedor/resultado/resultado-final/todos-lotes-itens/TodosLotesItens'

export default {
    name: 'ResultadoFinal',
    components: {
        MeusLotesItensVencedores,
        TodosLotesItens
    },
    data() {
        return {
            compraDiretaId: null
        }
    },
    computed: {
        ...mapState(['fornecedor', 'resumoProposta']),
        quantidadeCasasDecimais() {
            if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.disputaPor === 'UNITARIO') {
                return this.fornecedor.quantidadeCasasDecimaisCompraDireta
            }
            return 2
        },
        criterioJulgamento(){
            return this.resumoProposta.criterioJulgamento
        },
        simboloCriterioJulgamento(){
            return this.resumoProposta.simboloCriterioJulgamento
        },
        prefixSuffixValor(){
            return this.resumoProposta.prefixoValor
        },
        validarLancesPor(){
            return this.resumoProposta.intervaloLancesPor
        },
        placeHolderValorOuDesconto(){
            return this.resumoProposta.placeholderInputLances
        }

    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarResultadoTodosLotesEItens()
            await this.buscarMeusLotesVencedores()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarResultadoTodosLotesEItens() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_RESULTADO_DE_TODOS_LOTES_E_ITENS, this.compraDiretaId)
        },
        async buscarMeusLotesVencedores() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_MEUS_LOTES_E_ITENS_VENCEDORES, this.compraDiretaId)
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        }
    }
}
</script>

<style scoped lang="stylus">

</style>